/**
 * Represents a template created by the control
 * @hidden
 */
export class ControlTemplate {

    /**
     * The template as string which was created by the control.
     */
    public template: string;

    /**
     * The element inside of the template.
     */
    public element: JQuery;

    /**
     * Indicates if the control for this template is editable.
     */
    public editable: boolean;

    /**
     * An object which is used to extend the model (either Form ViewModel or Grid DataRow).
     */
    public modelExtension: { [index: string]: any };
}